import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Home from "./pages/Home/index.jsx";
import TermsOfUse from "./pages/TermsOfUse/index.jsx";
import InfoVerify from "./pages/InfoVerify/index.jsx";
import Login from "./pages/Login/index.jsx";
import Users from "./pages/Users/index.jsx";
import Team from "./pages/Team/index.jsx";
import Groups from "./pages/Groups/index.jsx";
import NotFoundPage from "./pages/NotFound/index.jsx";
import Main from "./components/Main.jsx";
import Files from "./pages/Files/index.jsx";
import HomeUnimed from "./pages/HomeUnimed/index.jsx";
import HomeConvenioGrupo from "./pages/HomeConvenioGrupo/index.jsx";
import HomeCho from "./pages/HomeCho/index.jsx";
import HomeRedeSus from "./pages/HomeRedeSus/index.jsx";
import HomeTumorBoard from "./pages/HomeTumorBoard/index.jsx";

import PrivateRoute from "./privateRoutes.jsx";
import PrivateFilesRoute from "./PrivateFilesRoutes.jsx";

export default function Routes() {
  const HomePage = (props) => <Main Page={Home} {...props} />;
  const FilesPage = (props) => <Main Page={Files} {...props} />;
  const UniPage = (props) => <Main Page={HomeUnimed} {...props} />;
  const ChoPage = (props) => <Main Page={HomeCho} {...props} />;
  const ConvenioGrupoPage = (props) => <Main Page={HomeConvenioGrupo} {...props} />;
  const RedeSusPage = (props) => <Main Page={HomeRedeSus} {...props} />;
  const TumorBoardPage = (props) => <Main Page={HomeTumorBoard} {...props} />;

  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute path="/" exact component={HomePage} />

        <Route path="/equipe" exact render={() => <Main Page={Team} />} />
        <Route path="/grupos" exact render={() => <Main Page={Groups} />} />
        <Route path="/usuarios" exact render={() => <Main Page={Users} />} />

        <Route path="/terms" exact component={TermsOfUse} />
        <Route path="/login" exact component={Login} />
        <Route path="/info-verify" exact component={InfoVerify} />

        <PrivateFilesRoute path="/files" exact component={FilesPage} />
        <PrivateFilesRoute path="/reports" exact component={UniPage} />
        <PrivateFilesRoute path="/reportsCho" exact component={ChoPage} />
        <PrivateFilesRoute path="/reportsConvenioGrupo" exact component={ConvenioGrupoPage} />
        <PrivateFilesRoute
          path="/reports-rede-sus"
          exact
          component={RedeSusPage}
        />
        <PrivateFilesRoute
          path="/tumor-board"
          exact
          component={TumorBoardPage}
        />

        <Route component={NotFoundPage} />
      </Switch>
    </BrowserRouter>
  );
}
